import * as React from 'react';

function SvgTenancyLength(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" {...props}>
      <path d="M33 2.2V2a2 2 0 00-2-2h-.4a2 2 0 00-2 2v.2H15.4V2a2 2 0 00-2-2H13a2 2 0 00-2 2v.2H4a4 4 0 00-4 4V40a4 4 0 004 4h36a4 4 0 004-4V6.2a4 4 0 00-4-4zm-7.15 35.2h-4.4V24.2h-3.3v-4.4h7.7zM4.4 11.2V8.6a2 2 0 012-2H11v2.2h4.4V6.6h13.2v2.2H33V6.6h4.6a2 2 0 012 2v2.6a2 2 0 01-2 2H6.4a2 2 0 01-2-2z" />
    </svg>
  );
}

export default SvgTenancyLength;
